import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { Link, useLocation } from 'react-router-dom';
import cn from 'classnames';
import { Typography, Button, TextButton } from 'seagull';
import styles from './FormComponents.module.scss';
export const FormContainer = (props)=>{
    const { className } = props, rest = _object_without_properties(props, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx("form", _object_spread_props(_object_spread({}, rest), {
        className: cn(styles.formContainer, className)
    }));
};
export const FormTitle = (props)=>{
    const { children } = props, rest = _object_without_properties(props, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({}, rest), {
        className: styles.title,
        children: children
    }));
};
export const FormSubTitle = (props)=>{
    const { children } = props, rest = _object_without_properties(props, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({}, rest), {
        className: styles.subTitle,
        children: children
    }));
};
export const FormDescription = (props)=>{
    const { children } = props, rest = _object_without_properties(props, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({}, rest), {
        className: styles.description,
        children: children
    }));
};
export const FormFields = (props)=>{
    const { children, className } = props, rest = _object_without_properties(props, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({}, rest), {
        className: cn(styles.formFields, className),
        children: children
    }));
};
export const VerticalFormFields = (props)=>{
    const { children, className } = props, rest = _object_without_properties(props, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({}, rest), {
        className: cn(styles.verticalFormFields, className),
        children: children
    }));
};
export const HorizontalFormFields = (props)=>{
    const { children, className } = props, rest = _object_without_properties(props, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({}, rest), {
        className: cn(styles.horizontalFormFields, className),
        children: children
    }));
};
export const Footer = (props)=>{
    const { children } = props, rest = _object_without_properties(props, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({}, rest), {
        className: styles.footer,
        children: children
    }));
};
export const FooterText = (props)=>{
    const { children } = props, rest = _object_without_properties(props, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx(Typography, _object_spread_props(_object_spread({}, rest), {
        as: "span",
        variant: "paragraph2",
        skin: "disabled",
        weight: "light",
        children: children
    }));
};
export const FooterLink = (props)=>{
    const { children, toInternalLink, onClick, target, toExternalLink, underline = 'none', testId } = props, rest = _object_without_properties(props, [
        "children",
        "toInternalLink",
        "onClick",
        "target",
        "toExternalLink",
        "underline",
        "testId"
    ]);
    const location1 = useLocation();
    let as, componentProps;
    if (toExternalLink || toInternalLink) {
        as = Link;
        const to = toInternalLink ? {
            pathname: toInternalLink,
            search: location1.search
        } : {
            pathname: toExternalLink
        };
        componentProps = {
            to,
            target
        };
    } else {
        as = 'button';
        componentProps = {
            type: 'button'
        };
    }
    return /*#__PURE__*/ _jsx(TextButton, _object_spread_props(_object_spread({}, rest, componentProps), {
        as: as,
        onClick: onClick,
        variant: "paragraph2",
        skin: "secondary",
        underline: underline,
        testId: testId,
        children: children
    }));
};
export const SubmitButtonField = (props)=>{
    const { disabled, isLoading, children, testId } = props;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.submitButtonField,
        children: /*#__PURE__*/ _jsx(Button, {
            disabled: disabled,
            loading: isLoading,
            type: "submit",
            testId: testId,
            children: children
        })
    });
};
export const ErrorMessage = (props)=>{
    return /*#__PURE__*/ _jsx(Typography, {
        skin: "error",
        variant: "paragraph2",
        testId: props.testId,
        className: styles.error,
        children: props.children
    });
};
export const LinkButton = (props)=>{
    const { toInternalLink, testId } = props, rest = _object_without_properties(props, [
        "toInternalLink",
        "testId"
    ]);
    return /*#__PURE__*/ _jsx(TextButton, _object_spread({
        as: Link,
        to: {
            pathname: toInternalLink,
            search: location.search
        },
        skin: "secondary",
        variant: "paragraph2",
        underline: "none",
        testId: testId
    }, rest));
};
